import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bda2f846"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-format"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "feed-card__profile_text" }
const _hoisted_4 = { class: "feed-card__content" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "feed-card__content_buttons" }
const _hoisted_7 = ["onClick", "data-accent"]
const _hoisted_8 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.27245 5C4.91284 5 3 6.91284 3 9.27246V9.48674C3 10.6548 3.45553 11.7768 4.26977 12.6143L11.7968 20.3565C11.9081 20.4709 12.0919 20.4709 12.2032 20.3565L19.7302 12.6143C20.5445 11.7768 21 10.6548 21 9.48674V9.27245C21 6.91284 19.0872 5 16.7275 5C15.5736 5 14.4686 5.46681 13.6642 6.29422L12.7764 7.20739C12.3512 7.64476 11.6488 7.64476 11.2236 7.20739L10.3358 6.29422C9.53136 5.46681 8.42644 5 7.27245 5ZM1 9.27246C1 5.80828 3.80827 3 7.27245 3C8.96664 3 10.5888 3.68533 11.7698 4.90006L12 5.13687L12.2302 4.90006C13.4112 3.68534 15.0334 3 16.7275 3C20.1917 3 23 5.80827 23 9.27245V9.48674C23 11.1755 22.3414 12.7977 21.1642 14.0085L13.6371 21.7506C12.7405 22.6729 11.2595 22.6729 10.3629 21.7506L2.83578 14.0085C1.65859 12.7977 1 11.1755 1 9.48674V9.27246Z",
  fill: "white"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 22 20",
  fill: "none"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0 6.27246C0 2.80828 2.80827 0 6.27245 0C7.96664 0 9.58879 0.685335 10.7698 1.90006L11 2.13687L11.2302 1.90006C12.4112 0.685336 14.0334 0 15.7275 0C19.1917 0 22 2.80827 22 6.27245V6.48674C22 8.17549 21.3414 9.79768 20.1642 11.0085L12.6371 18.7506C11.7405 19.6729 10.2595 19.6729 9.36285 18.7506L1.83578 11.0085C0.658586 9.79768 0 8.17549 0 6.48674V6.27246Z",
  fill: "#2FF77A"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12 3C12.5523 3 13 3.44772 13 4V12.9864C13.4297 12.5478 13.8307 12.0809 14.2 11.5885C14.5314 11.1466 15.1582 11.0571 15.6 11.3885C16.0418 11.7198 16.1314 12.3466 15.8 12.7885C15.0104 13.8413 14.0944 14.792 13.0731 15.6195C12.7608 15.8726 12.3801 16 12 16C11.6199 16 11.2392 15.8726 10.9269 15.6196C9.90559 14.792 8.98959 13.8413 8.2 12.7885C7.86863 12.3466 7.95817 11.7198 8.4 11.3885C8.84183 11.0571 9.46863 11.1466 9.8 11.5885C10.1693 12.0809 10.5703 12.5478 11 12.9864V4C11 3.44772 11.4477 3 12 3ZM3 14C3.55228 14 4 14.4477 4 15C4 17.2091 5.79086 19 8 19H16C18.2091 19 20 17.2091 20 15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15C22 18.3137 19.3137 21 16 21H8C4.68629 21 2 18.3137 2 15C2 14.4477 2.44772 14 3 14Z",
    fill: "white"
  })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M22.1928 2.77125C21.8641 2.45373 21.4551 2.22248 21.0055 2.09986C20.5558 1.97723 20.0806 1.96737 19.6258 2.07123L4.95715 5.02005C4.1124 5.13063 3.31678 5.46411 2.65987 5.98294C2.00296 6.50177 1.51087 7.18535 1.23901 7.95668C0.967144 8.72802 0.92631 9.55648 1.1211 10.3488C1.3159 11.1411 1.73858 11.8657 2.34156 12.4411L3.9166 13.9435C4.00185 14.0249 4.06945 14.1214 4.11554 14.2278C4.16164 14.3341 4.18531 14.448 4.18522 14.563V17.3351C4.18724 17.7249 4.28125 18.1092 4.46025 18.4595L4.45292 18.4656L4.47676 18.4884C4.74539 19.0039 5.18413 19.4208 5.72542 19.6749L5.74926 19.6977L5.75568 19.6907C6.12272 19.8615 6.52538 19.9512 6.93375 19.9532H9.83813C10.0811 19.953 10.3143 20.0449 10.4863 20.2087L12.0604 21.7111C12.4826 22.1185 12.9851 22.4422 13.539 22.6634C14.0929 22.8846 14.6871 22.999 15.2875 23C15.7879 22.9994 16.2848 22.9214 16.759 22.769C17.5597 22.518 18.2711 22.0585 18.8128 21.4422C19.3545 20.8259 19.705 20.0774 19.8247 19.2812L22.9189 5.25018C23.0333 4.81236 23.0266 4.35365 22.8993 3.91907C22.772 3.48448 22.5285 3.08894 22.1928 2.77125ZM5.21477 12.708L3.63881 11.2056C3.27184 10.8638 3.01464 10.4291 2.89739 9.95269C2.78015 9.47625 2.80773 8.97777 2.97689 8.51577C3.1409 8.04179 3.44409 7.62274 3.8504 7.30847C4.25672 6.99419 4.74905 6.79791 5.26886 6.74297L19.7917 3.82477L6.01696 16.9737V14.563C6.01835 14.2186 5.94817 13.8773 5.81047 13.5589C5.67278 13.2404 5.47031 12.9512 5.21477 12.708ZM18.0232 18.9819C17.9528 19.4652 17.7427 19.9202 17.4164 20.2959C17.0901 20.6715 16.6606 20.9529 16.176 21.1085C15.6914 21.2641 15.171 21.2877 14.6732 21.1767C14.1754 21.0656 13.7198 20.8244 13.3577 20.4799L11.7808 18.9749C11.5263 18.7306 11.2235 18.537 10.8901 18.4051C10.5566 18.2732 10.1991 18.2058 9.83813 18.2066H7.31238L21.089 5.06205L18.0232 18.9819Z",
    fill: "white"
  })
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 32 32",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M18.5 5C18.5 4.44772 18.9477 4 19.5 4H27C27.5523 4 28 4.44772 28 5V12.5C28 13.0523 27.5523 13.5 27 13.5C26.4477 13.5 26 13.0523 26 12.5V6H19.5C18.9477 6 18.5 5.55228 18.5 5Z",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M27.7071 4.29289C28.0976 4.68342 28.0976 5.31658 27.7071 5.70711L18.7071 14.7071C18.3166 15.0976 17.6834 15.0976 17.2929 14.7071C16.9024 14.3166 16.9024 13.6834 17.2929 13.2929L26.2929 4.29289C26.6834 3.90237 27.3166 3.90237 27.7071 4.29289Z",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.58579 8.58579C4.96086 8.21071 5.46957 8 6 8H14C14.5523 8 15 8.44772 15 9C15 9.55228 14.5523 10 14 10L6 10L6 26H22V18C22 17.4477 22.4477 17 23 17C23.5523 17 24 17.4477 24 18V26C24 26.5304 23.7893 27.0391 23.4142 27.4142C23.0391 27.7893 22.5304 28 22 28H6C5.46957 28 4.96086 27.7893 4.58579 27.4142C4.21071 27.0391 4 26.5304 4 26V10C4 9.46957 4.21071 8.96086 4.58579 8.58579Z",
    fill: "white"
  })
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "feed-card__content_tags" }
const _hoisted_24 = {
  key: 0,
  class: "feed-card__content_tag"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "17",
  height: "17",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.27245 5C4.91284 5 3 6.91284 3 9.27246V9.48674C3 10.6548 3.45553 11.7768 4.26977 12.6143L11.7968 20.3565C11.9081 20.4709 12.0919 20.4709 12.2032 20.3565L19.7302 12.6143C20.5445 11.7768 21 10.6548 21 9.48674V9.27245C21 6.91284 19.0872 5 16.7275 5C15.5736 5 14.4686 5.46681 13.6642 6.29422L12.7764 7.20739C12.3512 7.64476 11.6488 7.64476 11.2236 7.20739L10.3358 6.29422C9.53136 5.46681 8.42644 5 7.27245 5ZM1 9.27246C1 5.80828 3.80827 3 7.27245 3C8.96664 3 10.5888 3.68533 11.7698 4.90006L12 5.13687L12.2302 4.90006C13.4112 3.68534 15.0334 3 16.7275 3C20.1917 3 23 5.80827 23 9.27245V9.48674C23 11.1755 22.3414 12.7977 21.1642 14.0085L13.6371 21.7506C12.7405 22.6729 11.2595 22.6729 10.3629 21.7506L2.83578 14.0085C1.65859 12.7977 1 11.1755 1 9.48674V9.27246Z",
    fill: "white"
  })
], -1))
const _hoisted_26 = { class: "feed-card__text" }
const _hoisted_27 = ["href"]
const _hoisted_28 = {
  key: 2,
  class: "feed-card__panels"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "feed-card__panel_title" }, "Создатель:", -1))
const _hoisted_30 = { class: "feed-card__panel_body" }
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = { class: "feed-card__profile_text" }
const _hoisted_33 = {
  key: 1,
  class: "feed-card__panel"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "feed-card__panel_title" }, "Дата:", -1))
const _hoisted_35 = { class: "feed-card__panel_body" }
const _hoisted_36 = { class: "feed-card__panel_text" }

import { ref, Ref } from 'vue';
import { useRouter } from 'vue-router';
import { toast } from 'vue3-toastify';
import { WorksSevice } from '@/services/WorksService';
import { AuthService } from '@/services/AuthService';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseFeedCreation',
  props: {
    id: {},
    author: {},
    image: {},
    text: {},
    date: {},
    likes: {},
    preview: {},
    brand: {},
    format: { default: 'feed' }
  },
  setup(__props: any) {

const props = __props;



const router = useRouter();

function viewWork() {
	if (props.format === 'feed') router.push(`/work?id=${props.id}`);
}

const likeAmount: Ref<null | number> = ref(props.likes ?? null);
const isLiked: Ref<boolean> = ref(WorksSevice.likedWorks[props.id] === true);
async function likeWork() {
	if (isLiked.value) return;
	if (!AuthService.authorized) {
		router.push('/auth');
		return;
	}

	await WorksSevice.likeWork(props.id);
	WorksSevice.likedWorks = {
		...WorksSevice.likedWorks,
		[props.id]: true
	};
	toast.info('Лайк поставлен', { autoClose: 1500 });

	isLiked.value = true;
	if (likeAmount.value) likeAmount.value++;
}

function shareWork() {
	if (!props.preview) return;

	const shareData = {
		title: 'Burngram',
		text: `BURNGRAM запустился! Самая популярная работа выкупается, регистрируйетсь на новой платформе и монетизируйте свою активность.\n${props.preview}`
	};

	// Web Share API (only HTTPS, locally supported)
	if (navigator.share && navigator.canShare(shareData)) {
		navigator
			.share(shareData)
			.then(() => toast.info('Успешно поделились ссылкой'));
	}
	// Clipboard API
	else if (navigator.clipboard) {
		navigator.clipboard
			.writeText(props.preview)
			.then(() => toast.info('Ссылка скопирована'));
	}
}

async function downloadWork() {
	const response = await fetch(props.image);

	const blobImage = await response.blob();

	const href = URL.createObjectURL(blobImage);

	const anchorElement = document.createElement('a');
	anchorElement.href = href;
	anchorElement.download = `${props.text}.png`;

	document.body.appendChild(anchorElement);
	anchorElement.click();

	document.body.removeChild(anchorElement);
	window.URL.revokeObjectURL(href);
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: "feed-card",
    "data-format": _ctx.format
  }, [
    (_ctx.format === 'feed')
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 0,
          to: `/profile/user?id=${_ctx.author.user_id}`,
          class: "feed-card__profile"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _ctx.author.avatar,
              alt: _ctx.author.nickname,
              class: "feed-card__profile_image"
            }, null, 8, _hoisted_2),
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.author.nickname), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        onClick: viewWork,
        src: _ctx.image,
        alt: _ctx.text,
        class: "feed-card__content_image",
        draggable: "false"
      }, null, 8, _hoisted_5),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.format !== 'self-work')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _withModifiers(likeWork, ["prevent"]),
              class: "feed-card__content_button",
              "data-accent": isLiked.value
            }, [
              (!isLiked.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
                : (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13))
            ], 8, _hoisted_7))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _withModifiers(downloadWork, ["prevent"]),
              class: "feed-card__content_button"
            }, _hoisted_16, 8, _hoisted_14)),
        (_ctx.preview)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              onClick: _withModifiers(shareWork, ["prevent"]),
              class: "feed-card__content_button"
            }, _hoisted_19, 8, _hoisted_17))
          : _createCommentVNode("", true),
        (_ctx.brand)
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              class: "feed-card__content_button",
              href: _ctx.brand,
              target: "_blank",
              rel: "noopener noreferrer"
            }, _hoisted_22, 8, _hoisted_20))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_23, [
        (typeof likeAmount.value === 'number')
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("p", null, _toDisplayString(isLiked.value ? likeAmount.value + 1 : likeAmount.value), 1),
              _hoisted_25
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.text), 1),
    (_ctx.brand)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: _ctx.brand,
          target: "_blank",
          rel: "noopener noreferrer",
          class: "feed-card__button button button-md button-primary"
        }, " Бренд ", 8, _hoisted_27))
      : _createCommentVNode("", true),
    (_ctx.format === 'fullscreen' || _ctx.format === 'self-work')
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          (_ctx.format === 'fullscreen')
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: `/profile/user?id=${_ctx.author.user_id}`,
                class: "feed-card__panel"
              }, {
                default: _withCtx(() => [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("img", {
                      src: _ctx.author.avatar,
                      alt: _ctx.author.nickname,
                      class: "feed-card__profile_image"
                    }, null, 8, _hoisted_31),
                    _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.author.nickname), 1)
                  ])
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (_ctx.date)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.date), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})